import React from 'react'
import { VersionLink } from 'modules/versioning'
import { Tooltip, Link } from '@sketch/components'

import { GetArtboardInDocumentWithUuidQuery } from '@sketch/gql-types'
import { routes } from '@sketch/modules-common'

type SymbolArtboard = OmitSafe<
  NonNullable<GetArtboardInDocumentWithUuidQuery['artboardInDocumentWithUuid']>,
  '__typename'
>

interface SymbolLinksProps {
  symbolArtboard: SymbolArtboard | null
  shareIdentifier: string
  isSamePermanentArtboardShortId: boolean
  isForeign: boolean
}

export const SymbolUnavailable: React.FC = ({ children }) => (
  <Tooltip
    placement="top"
    content="This Symbol belongs to a Library that is unavailable"
  >
    {children}
  </Tooltip>
)

const SymbolLink: React.FC<SymbolLinksProps> = ({
  symbolArtboard,
  shareIdentifier,
  isSamePermanentArtboardShortId,
  isForeign,
  children,
}) => {
  // Data is not consistent for now, so we need to check that both exist
  // in order to link to a proper artboard (symbol masters are just arboards)
  if (
    !symbolArtboard?.isSymbolMaster ||
    !symbolArtboard?.permanentArtboardShortId ||
    shareIdentifier === '' ||
    isSamePermanentArtboardShortId
  ) {
    return <SymbolUnavailable>{children}</SymbolUnavailable>
  }

  // When linking to a foreign symbol we always link to the latest version,
  // but for internal symbols we want a versioned link
  return isForeign ? (
    <Link
      data-testid="inspector-symbol-link"
      to={routes.ARTBOARD_DETAIL.create({
        shareID: shareIdentifier,
        permanentArtboardShortId: symbolArtboard.permanentArtboardShortId as string,
      })}
    >
      {children}
    </Link>
  ) : (
    <VersionLink
      data-testid="inspector-symbol-link"
      to={{
        routeKey: 'ARTBOARD_DETAIL',
        routeParams: {
          shareID: shareIdentifier,
          permanentArtboardShortId: symbolArtboard.permanentArtboardShortId as string,
        },
      }}
    >
      {children}
    </VersionLink>
  )
}

export { SymbolLink }
